import { IgenomicsState } from '../../core/interfaces/genomics-state.interface';
import { createSelector } from '@ngrx/store';
import { IWorkflowRequest } from '@ispm/workflow/interfaces/workflow-request.interface';
import { IRevision } from '@ispm/workflow/interfaces/revision.interface';
import { IWorkflowJobItem } from '@ispm/workflow/interfaces/job-item.interface';
import { Workflow } from '@ispm/core/interfaces/workflow.interface';


const getActiveRevision = (workflow: IWorkflowRequest): any =>
  !!workflow ? workflow.revisions.find(revision => workflow.activeRevision === revision.id) : null;

const getActiveJob = (activeJobId: string, revision: IRevision): IWorkflowJobItem =>
  (revision && revision.items) ? revision.items.find(item => item.id === activeJobId) : null;

const getActiveJobId = (workflow: IWorkflowRequest): any => !!workflow ? workflow.activeJob : null;
const getActiveJobPurpose = (activeJob: IWorkflowJobItem): any => !!activeJob ? activeJob.purpose : null;
const getActiveJobInputs = (activeJob: IWorkflowJobItem): any => !!activeJob ? activeJob.inputs : null;
const getActiveReferences = (workflow: IWorkflowRequest): any => !!workflow ? workflow.references : null;


const getTestElapsedTime = (organizationConfiguration): any => organizationConfiguration ? organizationConfiguration.testElapsedTime : null;

const selectWorkflowFeature = (state: IgenomicsState) => state.workflowConfig;
const selectOrganisationConfig = (state: IgenomicsState) => state.users ? state.users.organizationConfiguration : undefined;

function getRevisionById(id: string, workflow: IWorkflowRequest): IRevision {
  return !!workflow && !!id ? workflow.revisions.find(revision => id === revision.id) : null;
}

export function getPractitionerReferenceByType(references, practType) {
  let id = "";
  if (references) {
    references.forEach((ref) => {
      if (ref.type == "practitioner") {
        const practitioner = JSON.parse(ref.value);
        if (practitioner.practType == practType) {
          id = practitioner.practId;
          return;
        }
      }
    });
  }
  return id;
}

export function getInputByKeyAndTimestamp(inputs, key) {
  if( !(inputs && key) ) {
    return null;
  }

  const latest = {item: null, timestamp: null};
  key = key.toLowerCase();

  for(const input of inputs){
    if(input.key && input.key.toLowerCase() === key) {
      const timestamp = new Date(input.args).getTime();
      if(timestamp > latest.timestamp) {
        latest.item = input;
        latest.timestamp = timestamp;
      }
    }
  }

  return latest.item;
}

export const selectActiveWorkflow = createSelector(selectWorkflowFeature, workflowConfigState =>  workflowConfigState && workflowConfigState.activeWorkflow);
export const selectActiveWorkflowActiveJobPurpose = createSelector(selectActiveWorkflow, activeWorkflow =>  activeWorkflow && activeWorkflow.activeJobPurpose);
export const selectResourceMap = createSelector(selectWorkflowFeature, workflowConfigState =>  workflowConfigState && workflowConfigState.resourcesMap);
export const selectActiveJobId = createSelector(selectActiveWorkflow, getActiveJobId);
export const selectRequestedRevisionId = createSelector(selectResourceMap,map => map && map.requestedRevision);
export const selectActiveRevision = createSelector(selectActiveWorkflow, getActiveRevision);
export const selectActiveJob = createSelector([selectActiveJobId, selectActiveRevision], getActiveJob);
export const selectActiveJobPurpose = createSelector(selectActiveJob, getActiveJobPurpose);
export const selectActiveJobInputs = createSelector(selectActiveJob, getActiveJobInputs);
export const selectActiveReferences = createSelector(selectActiveWorkflow, getActiveReferences);
export const selectTestElapsedTime = createSelector(selectOrganisationConfig, getTestElapsedTime);
export const selectLatestRevisionStatus = createSelector(selectActiveWorkflow, activeWorkflow => activeWorkflow && activeWorkflow.latestRevisionStatus);
export const selectActiveWorkflowAndResourceMap = createSelector(selectWorkflowFeature, workflowConfigState =>  workflowConfigState && workflowConfigState.activeWorkflow && workflowConfigState.resourcesMap);

export const selectRequestedRevision = createSelector([selectRequestedRevisionId, selectActiveWorkflow], getRevisionById);

export const selectActiveJobInputByKey = (key: string) => { return createSelector(
  selectActiveJobInputs,
  inputs => Workflow.getInput(inputs, key)
);
};

export const selectActivePractitionerReferenceByType = (practType: string) => { return createSelector(
  selectActiveReferences,
  references => getPractitionerReferenceByType(references, practType)
)};

export const selectActiveReferencesByKey = (key: string) => { return createSelector(
    selectActiveReferences,
  references => Workflow.getReference(references, key));
};

export const selectActiveReferencesByPractType = (practType: string) => {
  return createSelector(
    selectActiveReferences,
    references => Workflow.getReferencesByPractType(references, practType));
};

export const selectActiveReferencesValueByKey = (key: string) => { return createSelector(
  selectActiveReferencesByKey(key),
  reference => !!reference ? reference.value : null);
};

export const selectActiveJobLatestInputByKey = (key: string) => {
  return createSelector(
    selectActiveJobInputs,  (inputs) => getInputByKeyAndTimestamp(inputs, key)
  )
};


export const selectActiveJobInputValueByKey = (key: string) => { return createSelector(
    selectActiveJobInputByKey(key),
    input => !!input ? input.value : null);
};


